import { fg } from '@atlaskit/platform-feature-flags';

import { isSSR } from '../is-ssr';

/**
 * SSR-aware evaluation of the BSC flat pattern file format rollout.
 *
 * The frontend and SSR paths roll out on independent schedules (COOK-577): reading one shared
 * flag from both caused Confluence SSR/hydration mismatches. In an SSR context we read the
 * SSR-specific gate; otherwise we read the original frontend gate.
 */
export const isFlatPatternFileFormatEnabled = (): boolean =>
	isSSR()
		? fg('platform_bsc_ssr_flat_pattern_file_format')
		: fg('platform_bsc_flat_pattern_file_structure');
